// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedSlitLamp_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8 0H20V8H15.7896C15.1758 9.53228 14.1029 10.8115 12.7071 12.2072C12.4515 12.4628 12.0076 12.9088 11.6269 13.4533C11.2313 14.0191 11 14.5579 11 15.0001C11 15.7288 11.2633 16.2018 11.6019 16.5027C11.9588 16.82 12.4631 17.0001 13 17.0001H18.9999V19.0001H16V21H22L23 24H2L3 21H5V15H7V21H14V19.0001H13C12.0369 19.0001 11.0412 18.6802 10.2731 17.9975C9.4867 17.2985 9 16.2715 9 15.0001C9 13.9424 9.51181 12.988 9.98775 12.3073C10.474 11.6119 11.0242 11.0617 11.2856 10.8004L11.2929 10.793C12.3449 9.74104 13.0842 8.87266 13.5753 8H8V6H7V7H5V1H7V2H8V0ZM16.0225 6C15.9635 5.82929 15.9828 5.96232 15.9942 6H10V2H18V6H16.0225Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedSlitLamp is a generated icon component.
 */
let IconMedSlitLamp = IconMedSlitLamp_1 = class IconMedSlitLamp extends IconBaseElement {
    render() {
        return html `${IconMedSlitLamp_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedSlitLamp.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedSlitLamp = IconMedSlitLamp_1 = __decorate([
    customElement('zui-icon-med-slit-lamp')
], IconMedSlitLamp);
export { IconMedSlitLamp };
